var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54207",
    "data-name": "Group 54207",
    transform: "translate(0 0.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo_1_",
    "data-name": "facebook-logo (1)",
    transform: "translate(15.296 8.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M133.072,7.876V5.8a4.564,4.564,0,0,1,.043-.722,1.4,1.4,0,0,1,.2-.5.8.8,0,0,1,.5-.343,3.53,3.53,0,0,1,.912-.095h2.071V0h-3.311a5.389,5.389,0,0,0-4.128,1.363A5.744,5.744,0,0,0,128.1,5.382V7.876h-2.48v4.142h2.48V24.035h4.974V12.018h3.31l.438-4.142Z",
    transform: "translate(-125.619)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_103090",
    "data-name": "Path 103090",
    transform: "translate(0 -0.204)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 3 C 16.19202995300293 3 11.67182922363281 4.872329711914062 8.272079467773438 8.272079467773438 C 4.872329711914062 11.67182922363281 3 16.19202995300293 3 21 C 3 25.80797004699707 4.872329711914062 30.32817077636719 8.272079467773438 33.72792053222656 C 11.67182922363281 37.12767028808594 16.19202995300293 39 21 39 C 25.80797004699707 39 30.32817077636719 37.12767028808594 33.72792053222656 33.72792053222656 C 37.12767028808594 30.32817077636719 39 25.80797004699707 39 21 C 39 16.19202995300293 37.12767028808594 11.67182922363281 33.72792053222656 8.272079467773438 C 30.32817077636719 4.872329711914062 25.80797004699707 3 21 3 M 21 0 C 32.59798049926758 0 42 9.402019500732422 42 21 C 42 32.59798049926758 32.59798049926758 42 21 42 C 9.402019500732422 42 0 32.59798049926758 0 21 C 0 9.402019500732422 9.402019500732422 0 21 0 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.ddd738a19ad4d468337871e3cf0294c7.svg";
export { ForwardRef as ReactComponent };